import Vue from 'vue'
import VueRouter from 'vue-router'

//import HomeView from '@/views/Home.vue'
import StatementView from '@/views/Statement.vue'
//import PortfolioView from '@/views/Portfolio.vue'
import WorkView from '@/views/Work.vue'
import CvView from '@/views/Cv.vue'
import ContactView from '@/views/Contact.vue'
import PolicyView from '@/views/PrivacyPolicy.vue'
import TermsView from '@/views/TermsCondition.vue'
// Store routes disabled for now
// import PrintView from '@/views/PrintCollection.vue'
// import PrintItemView from '@/views/Item.vue'


Vue.use(VueRouter)

const routes = [
  {path: '/',name: 'home',component: WorkView,
    meta: { title: 'Marina SaMont — Surrealist Painter', description: 'Surrealist paintings blending classical technique with contemporary psychological themes. New works and exhibitions.' } },
  {path: '/work',name: 'paintings',component: WorkView,
    meta: { title: 'Artworks — Marina SaMont ', description: 'Surrealist paintings blending classical technique with contemporary psychological themes. New works and exhibitions.' } },
  {path: '/cv',name: 'exhibitions',component: CvView,
    meta: { title: 'CV — Marina SaMont', description: 'Exhibitions, education, and career of surrealist artist Marina SaMont.' } },
  {path: '/statement',name: 'artist',component: StatementView,
    meta: { title: 'Artist Statement — Marina SaMont', description: 'The ideas, symbolism, and process behind Marina SaMont\'s surrealist work.' } },
  // Store routes disabled for now
  // {path: '/print',name: 'print',component: PrintView},
  // {path: '/print/:slug',name: 'print-item',component: PrintItemView},
  {path: '/contact',name: 'contact',component: ContactView,
    meta: { title: 'Contact — Marina SaMont', description: 'Get in touch with surrealist artist Marina SaMont for inquiries and acquisitions.' } },
  {path: '/privacy-policy',name: 'policy',component: PolicyView},
  {path: '/terms-and-conditions',name: 'terms',component: TermsView}
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    window.scrollTo(0, 0)
  }
})

router.afterEach((to) => {
  document.title = to.meta.title || 'Marina SaMont'
  const desc = document.querySelector('meta[name="description"]')
  if (desc && to.meta.description) desc.setAttribute('content', to.meta.description)
})

export default router
